<div class="config-layout-shell d-flex flex-row flex-nowrap px-0">
  <div
    v-if="show_mobile_drawer && !should_hide_sidebar"
    class="mobile-backdrop"
    @click="close_mobile_sidebar"
  ></div>

  <div v-if="show_mobile_drawer && !should_hide_sidebar" class="mobile-drawer">
    <button
      class="mobile-drawer-close btn p-0 border-0 bg-transparent"
      @click="close_mobile_sidebar"
      aria-label="Close menu"
    >
      <i class="bi bi-x-lg fs-5"></i>
    </button>
    <ConfigSidebar @close="close_mobile_sidebar" />
  </div>

  <div
    v-if="!should_hide_sidebar"
    :class="[
      'sidebar-shell d-none d-lg-flex',
      is_sidebar_hidden ? 'sidebar-shell-collapsed' : 'sidebar-shell-expanded'
    ]"
  >
    <div class="sidebar-col">
      <div class="flex-grow-1 h-100">
        <ConfigSidebar @close="is_sidebar_hidden = true" />
      </div>
    </div>

    <button
      type="button"
      class="sidebar-toggle-arrow d-none d-lg-flex align-items-center justify-content-center position-absolute btn-primary-dark rounded-circle shadow border-0"
      :class="is_sidebar_hidden ? 'arrow-collapsed' : 'arrow-expanded'"
      @click="is_sidebar_hidden = !is_sidebar_hidden"
    >
      <i
        class="bi text-white fs-6"
        :class="is_sidebar_hidden ? 'bi-chevron-right' : 'bi-chevron-left'"
      ></i>
    </button>
  </div>

  <div class="config-layout-content d-flex flex-column flex-grow-1 min-w-0">
    <navbar
      :show_mobile_drawer="show_mobile_drawer"
      :hide_hamburger="should_hide_sidebar"
      @toggle-sidebar="toggle_sidebar"
      @toggle-ai-sidebar="toggle_ai_sidebar"
      @open-new-workflow-modal="open_new_workflow_modal"
      :show_ai_sidebar="show_ai_sidebar"
      class="config-top-navbar w-100 flex-shrink-0"
    />

    <div class="config-shell-body d-flex flex-row position-relative flex-grow-1 min-h-0 w-100">
      <div class="main-content-wrapper transition-all d-flex flex-column flex-grow-1 min-h-0">
        <div class="main-content border-card rounded-0 overflow-auto scroll-container">
          <router-view class="mt-1"></router-view>
        </div>
      </div>

      <div v-if="!should_hide_sidebar && show_ai_sidebar" class="d-none d-xl-flex flex-shrink-0 h-100">
        <ComplyonAiSidebar />
      </div>
    </div>
  </div>

  <teleport to="body">
    <div
      v-if="show_search_palette"
      class="search-palette-backdrop"
      @click="close_search_palette"
    >
      <div class="search-palette shadow-lg" role="dialog" aria-modal="true" aria-label="Search pages" @click.stop>
        <div class="search-palette-header d-flex align-items-center gap-3">
          <i class="bi bi-search text-secondary fs-5"></i>
          <input
            ref="searchPaletteInput"
            v-model="search_query"
            type="text"
            class="search-palette-input form-control border-0 shadow-none"
            placeholder="Search workflows, suppliers, contracts, evidence, controls..."
            aria-label="Search pages"
          />
          <button
            type="button"
            class="search-palette-key text-uppercase btn btn-light"
            @click="close_search_palette"
          >
            esc
          </button>
        </div>

        <div class="search-palette-body">
          <div
            v-if="!search_palette_sections.length"
            class="search-palette-empty text-secondary px-3 py-4"
          >
            No pages match your search.
          </div>

          <template v-else>
            <section
              v-for="section in search_palette_sections"
              :key="section.id"
              class="search-palette-section"
            >
              <div class="search-palette-section-label">{{ section.label }}</div>

              <div class="d-flex flex-column">
                <button
                  v-for="item in section.items"
                  :key="item.id"
                  type="button"
                  class="search-palette-item btn d-flex align-items-center justify-content-between w-100 text-start"
                  @click="go_to_palette_route(item.route_name)"
                >
                  <span class="d-flex align-items-center gap-3 min-w-0">
                    <i :class="['bi', item.icon, 'text-secondary flex-shrink-0']"></i>
                    <span class="search-palette-item-label text-truncate">{{ item.label }}</span>
                  </span>
                  <span class="search-palette-item-type">Page</span>
                </button>
              </div>
            </section>
          </template>
        </div>

        <div class="search-palette-footer d-flex align-items-center justify-content-between gap-3">
          <div class="search-palette-hint"><span>↵</span> open</div>
          <div class="d-flex align-items-center gap-3">
            <div class="search-palette-hint"><span>↑↓</span> navigate</div>
            <div class="search-palette-hint"><span>esc</span> close</div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <div
    v-if="show_new_workflow_modal"
    class="new-workflow-modal-backdrop"
    @click.self="close_new_workflow_modal"
  >
    <div class="new-workflow-modal-dialog modal-dialog-centered" role="dialog" aria-modal="true" aria-labelledby="new_workflow_modal_title">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg overflow-hidden new-workflow-modal-content">
        <div class="new-workflow-modal-header d-flex align-items-start justify-content-between gap-3 border-bottom">
          <div class="min-w-0">
            <div id="new_workflow_modal_title" class="new-workflow-modal-title">New workflow</div>
            <div class="new-workflow-modal-subtitle">
              Create a controlled process with owner, risk, evidence requirements, approval route and linked controls.
            </div>
          </div>
          <button
            type="button"
            class="btn-close modal-btn-close new-workflow-modal-close flex-shrink-0"
            aria-label="Close"
            @click="close_new_workflow_modal"
          ></button>
        </div>

        <div class="new-workflow-modal-scroll">
          <div class="new-workflow-modal-body">
            <div class="mb-3">
              <label class="case-owner-new-case-label text-uppercase mb-2">Workflow name</label>
              <input
                type="text"
                class="form-control case-owner-new-case-control"
                placeholder="e.g. Supplier onboarding · NewGX Capital"
              />
            </div>

            <div class="row g-3 mb-3">
              <div class="col-12 col-md-6">
                <label class="case-owner-new-case-label text-uppercase mb-2">Workflow type</label>
                <select class="form-select case-owner-new-case-control">
                  <option>Supplier onboarding</option>
                  <option>Payment release</option>
                  <option>Contract review</option>
                  <option>Compliance review</option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="case-owner-new-case-label text-uppercase mb-2">Owner</label>
                <select class="form-select case-owner-new-case-control">
                  <option>Pearl Naidoo · CCO</option>
                  <option>P. Naidoo · Procurement Officer</option>
                  <option>CISO · M. Khoza</option>
                  <option>Legal · A. de Wet</option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label class="case-owner-new-case-label text-uppercase mb-2">Risk level</label>
              <div class="d-flex flex-wrap gap-2">
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-chip">Low</button>
                <button type="button" class="btn rounded-pill new-workflow-chip is-selected">Medium</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-chip">High</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-chip">Critical</button>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-12 col-md-6">
                <label class="case-owner-new-case-label text-uppercase mb-2">Due date</label>
                <input type="date" class="form-control case-owner-new-case-control" />
              </div>
              <div class="col-12 col-md-6">
                <label class="case-owner-new-case-label text-uppercase mb-2">Linked policy</label>
                <select class="form-select case-owner-new-case-control">
                  <option>Procurement policy v3</option>
                  <option>Delegation of authority v1</option>
                  <option>Data privacy policy v2</option>
                  <option>Controls library v4</option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label class="case-owner-new-case-label text-uppercase mb-2">Required evidence</label>
              <div class="d-flex flex-wrap gap-2">
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">Tax certificate</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">BBBEE</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">Approval log</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">Signed contract</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">RFQ pack</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">DPA</button>
                <button type="button" class="btn btn-outline-secondary rounded-pill new-workflow-evidence-chip">Training certificate</button>
              </div>
              <div class="mt-2 text-secondary new-workflow-helper-copy">
                Click to add evidence requirements. The workflow will block until each item is attached and validated.
              </div>
            </div>

            <div class="mb-3">
              <label class="case-owner-new-case-label text-uppercase mb-2">Description</label>
              <textarea
                class="form-control case-owner-new-case-control case-owner-new-case-textarea new-workflow-description"
                rows="4"
                placeholder="Describe the compliance request and required evidence."
              ></textarea>
            </div>
          </div>
        </div>

        <div class="new-workflow-modal-footer d-flex justify-content-end align-items-center gap-2 border-top">
          <button type="button" class="btn btn-link text-decoration-none text-secondary px-0 fw-semibold" @click="close_new_workflow_modal">
            Cancel
          </button>
          <button type="button" class="btn btn-primary-dark config-navbar-primary-action d-inline-flex align-items-center gap-2">
            <i class="bi bi-plus-lg"></i>
            <span>Create workflow</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
